import { render, staticRenderFns } from "./DashboardAiGuides.vue?vue&type=template&id=398491d2&scoped=true"
import script from "./DashboardAiGuides.vue?vue&type=script&lang=js"
export * from "./DashboardAiGuides.vue?vue&type=script&lang=js"
import style0 from "./DashboardAiGuides.vue?vue&type=style&index=0&id=398491d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "398491d2",
  null
  
)

export default component.exports